import { type Registry as Services, service } from '@ember/service';
import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { tracked } from '@glimmer/tracking';
import { Type } from '@warp-drive/core-types/symbols';
import type { TotalRevenueBreakdownTrendReference } from 'lumen/models';
import type { HoteldateTransformReturn } from 'lumen/transforms/hoteldate';

export default class TotalRevenueBreakdownTrendItem extends Model {
  [Type] = 'total-revenue/breakdown/trend-item' as const;

  @hasMany('total-revenue/breakdown/trend-reference', {
    async: false,
    inverse: 'totalRevenueItem',
  })
  declare referenceValues: HasMany<TotalRevenueBreakdownTrendReference>;

  @attr('string') declare aggregation: 'day' | 'week' | 'month';
  @attr('hoteldate') declare date: NonNullable<HoteldateTransformReturn>;
  @attr('number') declare value: number;

  @service declare totalRevenue: Services['total-revenue'];

  @tracked capacity?: number;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedValue() {
    return this.totalRevenue.formatValue(this.valueOrPAR);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get valueOrPAR() {
    return this.totalRevenue.isPerAvailableRoom
      ? this.totalRevenue.calculatePAR(this.value, this.capacity)
      : this.value;
  }
}
